import { useEffect, useState } from 'react';
import clsx from 'clsx';
import * as R from 'ramda';

import { gwrrSchema } from '@atom/constants/customReportSchemaConstants';
import { MediaItem } from '@atom/types/media';
import api from '@atom/utilities/api';
import { MEDIA_ENDPOINT } from '@atom/utilities/endpoints';

import ChildAssessmentTable from './ChildAssessmentTable';
import ElementAssessmentRow from './ElementAssessmentRow';
import PhotoTile from './PhotoTile';

import classes from '../workOrderDetailPdfReport.module.css';

interface Props {
  element?: any;
  workOrderId?: string;
  setOtherPhotosLoading?: (currentLoading: { [id: string]: boolean }) => void;
}

const AssessmentTable = ({
  element,
  setOtherPhotosLoading,
  workOrderId,
}: Props) => {
  const [photos, setPhotos] = useState<MediaItem[]>([]);

  useEffect(() => {
    const getMedia = async () => {
      const subElementIds = R.pathOr([], ['elements'], element).map(
        item => item.id,
      );

      const data = {
        subjectTypes: 'workOrderAsset',
        parentSubjectId: workOrderId,
        subjectIds: [element.id, ...subElementIds].join(','),
      };

      const res = await api.get(MEDIA_ENDPOINT, data);

      setPhotos(res.data);
      // @ts-ignore
      setOtherPhotosLoading(currentLoading => ({
        ...currentLoading,
        assessmentTable: false,
      }));
    };

    getMedia();
  }, [element]);

  return (
    <>
      <div className={classes.tableWrapper}>
        <table>
          <thead>
            <tr className={classes.tableHeader}>
              <th className={classes.tableHeaderCell}>Structure</th>
              <th className={classes.tableHeaderCell}>Condition Rating</th>
              <th className={clsx(classes.tableHeaderCell, classes.comment)}>
                Comment
              </th>
              <th className={classes.tableHeaderCell}>Repair Recommendation</th>
              <th className={classes.tableHeaderCell}>Priority</th>
              <th className={classes.tableHeaderCell}>Assessment Flag</th>
            </tr>
          </thead>
          <tbody>
            <ElementAssessmentRow
              key={element.id}
              element={element}
              schemaIds={R.values(
                R.omit(
                  ['boredAtId', 'shellId', 'voidId'],
                  gwrrSchema.poolAttributes,
                ),
              )}
              isAssessmentReport
            />
          </tbody>
        </table>
        {element?.elements && (
          <ChildAssessmentTable
            key={`${element.id} elements`}
            elements={element.elements}
          />
        )}
      </div>
      <div>
        {!!photos.length && (
          <PhotoTile
            photos={photos}
            title={element.name}
            elements={element.elements}
            id={element.id}
            setOtherPhotosLoading={setOtherPhotosLoading}
          />
        )}
      </div>
    </>
  );
};

export default AssessmentTable;
